import type * as React from "react";

import { cx } from "../../lib/cx";
import s from "./Switch.module.css";

export interface SwitchProps extends Omit<React.ComponentPropsWithoutRef<"input">, "type" | "role"> {
  label?: React.ReactNode;
  /** Segunda línea, más chica y apagada. */
  description?: React.ReactNode;
  /** plain = pista y etiqueta sueltas (default); pill = dentro de una píldora con borde, que se pinta de accent-50
   *  al prenderse: el interruptor de una barra ("Mostrar historial"). */
  variant?: "plain" | "pill";
}

/**
 * Interruptor de efecto inmediato (publicar, activar un cartel). Si el valor
 * se guarda con un formulario, va `Checkbox`. Es un `<input type="checkbox"
 * role="switch">` oculto: el teclado y el foco son los nativos, el dibujo es
 * CSS sobre `:checked`.
 */
export function Switch({ label, description, variant = "plain", className, style, disabled, ...rest }: SwitchProps) {
  return (
    <label
      className={cx(s.envoltorio, className)}
      style={style}
      data-variant={variant === "pill" ? "pill" : undefined}
      data-disabled={disabled ? "" : undefined}
    >
      <input type="checkbox" role="switch" className={s.oculto} disabled={disabled} {...rest} />
      <span className={s.pista} aria-hidden="true">
        <span className={s.perilla} />
      </span>
      {label || description ? (
        <span className={s.texto}>
          {label ? <span className={s.etiqueta}>{label}</span> : null}
          {description ? <span className={s.descripcion}>{description}</span> : null}
        </span>
      ) : null}
    </label>
  );
}
